import { useRef, useEffect } from 'react'
import ErrorIcon from '@mui/icons-material/Report'
import { Title } from 'react-admin'
import { useLocation } from 'react-router'
import config from '../config'

const InternalError = (props) => {
  const { error, errorInfo, resetErrorBoundary } = props
  const { pathname } = useLocation()
  const originalPathname = useRef(pathname)

  // Effect that resets the error state whenever the location changes
  useEffect(() => {
    if (pathname !== originalPathname.current) {
      resetErrorBoundary()
    }
  }, [pathname, resetErrorBoundary])

  return (
    <>
      <Title title="Error" />
      <h1>
        <ErrorIcon /> Un problème est survenu{' '}
      </h1>
      {config.env !== 'production' && (
        <details>
          <h2>{error.toString()}</h2>
          {errorInfo === null ? '' : errorInfo.componentStack}
        </details>
      )}
      <p>
        Si vous pensez qu&apos;il s&apos;agit d&apos;un problème technique,
        merci d&apos;expliquer les étapes pour reproduire le problème via le
        lien ci-dessous. N&apos;oubliez pas d&apos;indiquer qui vous êtes afin
        de pouvoir vous contacter en cas de besoin ou vous tenir informer.
      </p>
      <a
        target="_blank"
        href="https://www.hello-syndic.fr/contact-it-bug"
        rel="noreferrer"
      >
        Reporter un problème
      </a>
    </>
  )
}

export default InternalError
